import { UserClaims } from "@okta/okta-auth-js";
import React from "react";
import { UserRole } from "../lib/models/enums";
import { SFAccount } from "../lib/models/sf-account.model";
import { SFUserProfile } from "../lib/models/sf-user-profile.model";
import { UserPreference } from "../lib/types/UserPreference";

export interface IUserContext {
  user: UserClaims | null;
  sfProfile: SFUserProfile | null;
  sfAccounts: Array<SFAccount>;
  exceptionBalance: number | null;
  role: UserRole | null;
  isEmployee: boolean;
  userPreferences: UserPreference | null;
  savePreferencesHelper: (preferences: { [key: string]: any }) => Promise<void>;
}

export const UserContext = React.createContext<IUserContext | undefined>(
  undefined
);
